module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -145,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.21380846325167,
						"dataLabels": {
							"enabled": true,
							"format": "2160"
						}
					},
					{
						"y": 86.41425389755011,
						"dataLabels": {
							"enabled": true,
							"format": "1940"
						}
					},
					{
						"y": 82.76169265033407,
						"dataLabels": {
							"enabled": true,
							"format": "1858"
						}
					},
					{
						"y": 76.57015590200446,
						"dataLabels": {
							"enabled": true,
							"format": "1719"
						}
					},
					{
						"y": 64.89977728285078,
						"dataLabels": {
							"enabled": true,
							"format": "1457"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.54224270353302,
						"dataLabels": {
							"enabled": true,
							"format": "635"
						}
					},
					{
						"y": 79.87711213517666,
						"dataLabels": {
							"enabled": true,
							"format": "520"
						}
					},
					{
						"y": 76.036866359447,
						"dataLabels": {
							"enabled": true,
							"format": "495"
						}
					},
					{
						"y": 69.89247311827957,
						"dataLabels": {
							"enabled": true,
							"format": "455"
						}
					},
					{
						"y": 53.3026113671275,
						"dataLabels": {
							"enabled": true,
							"format": "347"
						}
					},
					{
						"y": null
					},
					{
						"y": 94.35215946843853,
						"dataLabels": {
							"enabled": true,
							"format": "284"
						}
					},
					{
						"y": 80.39867109634552,
						"dataLabels": {
							"enabled": true,
							"format": "242"
						}
					},
					{
						"y": 73.421926910299,
						"dataLabels": {
							"enabled": true,
							"format": "221"
						}
					},
					{
						"y": 66.11295681063123,
						"dataLabels": {
							"enabled": true,
							"format": "199"
						}
					},
					{
						"y": 43.18936877076412,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.1147943523634,
						"dataLabels": {
							"enabled": true,
							"format": "4746"
						}
					},
					{
						"y": 85.22611008798854,
						"dataLabels": {
							"enabled": true,
							"format": "4165"
						}
					},
					{
						"y": 81.3587067730714,
						"dataLabels": {
							"enabled": true,
							"format": "3976"
						}
					},
					{
						"y": 75.87476979742172,
						"dataLabels": {
							"enabled": true,
							"format": "3708"
						}
					},
					{
						"y": 66.13464293022304,
						"dataLabels": {
							"enabled": true,
							"format": "3232"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.1843778383288,
						"dataLabels": {
							"enabled": true,
							"format": "1070"
						}
					},
					{
						"y": 87.01180744777474,
						"dataLabels": {
							"enabled": true,
							"format": "958"
						}
					},
					{
						"y": 82.6521344232516,
						"dataLabels": {
							"enabled": true,
							"format": "910"
						}
					},
					{
						"y": 77.02089009990918,
						"dataLabels": {
							"enabled": true,
							"format": "848"
						}
					},
					{
						"y": 58.94641235240691,
						"dataLabels": {
							"enabled": true,
							"format": "649"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.786191536748329,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.185185185185187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.226804123711336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.4811625403659825,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.241419429901104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.457757296466978,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.11023622047244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.807692307692313,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.080808080808078,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.73626373626374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.6478405315614655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.7887323943662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.677685950413228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.954751131221718,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.67336683417085,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.8852056476365906,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.24188790560472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.537815126050415,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.7404426559356185,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.837108953613807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.815622161671205,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.467289719626171,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.0104384133611735,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.813186813186811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.46698113207547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2245"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=651"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=301"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4887"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1101"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2245,
				2160,
				1940,
				1858,
				1719,
				1457
			],
			"Interior Health": [
				651,
				635,
				520,
				495,
				455,
				347
			],
			"Northern Health": [
				301,
				284,
				242,
				221,
				199,
				130
			],
			"Vancouver Coastal Health": [
				4887,
				4746,
				4165,
				3976,
				3708,
				3232
			],
			"Vancouver Island Health": [
				1101,
				1070,
				958,
				910,
				848,
				649
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 171
// module chunks = 0